import React, { useState, useEffect } from "react";
import ECLBlock from "../ECLBlock";

export default function Section(props) {
   //Track whether HTML is mounted (So we can ignore initial details event when they start open)
   const [mounted, setMounted] = useState(false);

   useEffect(() => {
      setMounted(true);
   }, []);

   function updateCollapse(e) {
      e.preventDefault();
      e.stopPropagation();
      //If react and the native component get desynced, and it wants to flutter, just return null.
      if (
         (props.block.react.collapsed === true &&
            e.nativeEvent.newState === "closed") ||
         (props.block.react.collapsed === false &&
            e.nativeEvent.newState === "open")
      ) {
         return null;
      }
      //if the element is not mounted, that means this is the initial draw, and the toggle event should be disregarded.
      if (!mounted) {
         return null;
      }
      props.setFlatDoc({
         ...props.flatDoc,
         [props.flatKey]: {
            ...props.flatDoc[props.flatKey],
            react: {
               ...props.flatDoc[props.flatKey].react,
               collapsed: !props.flatDoc[props.flatKey].react.collapsed,
            },
         },
      });
   }

   if (props.block.data.isCollapsible) {
      //TODO: Re-enable collapsed view
      // if (props.block.react.collapsed) {
      //    return (
      //       <>
      //          <details onToggle={updateCollapse}>
      //             <summary>{props.block.data.title}</summary>
      //          </details>
      //       </>
      //    );
      // } else {
      return (
         <>
            <details onToggle={updateCollapse} open>
               <summary>{props.block.data.title}</summary>
               {props.block.children &&
                  props.block.children.map((c) => (
                     <ECLBlock
                        key={c}
                        block={props.flatDoc[c]}
                        project={props.project}
                        flatDoc={props.flatDoc}
                        setFlatDoc={props.setFlatDoc}
                        flatKey={c}
                        headlist={props.headlist}
                        parentDoc={props.parentDoc}
                        revisionCount={props.revisionCount}
                        incrementRevision={props.incrementRevision}
                        navigateTo={props.navigateTo}
                        setNavigateTo={props.setNavigateTo}
                     />
                  ))}
            </details>
         </>
      );
      // }
   } else {
      return (
         <>
            <h2>{props.block.data.title}</h2>
            {props.block.children &&
               props.block.children.map((c) => (
                  <ECLBlock
                     key={c}
                     block={props.flatDoc[c]}
                     project={props.project}
                     flatDoc={props.flatDoc}
                     setFlatDoc={props.setFlatDoc}
                     flatKey={c}
                     headlist={props.headlist}
                     parentDoc={props.parentDoc}
                     revisionCount={props.revisionCount}
                     incrementRevision={props.incrementRevision}
                     navigateTo={props.navigateTo}
                     setNavigateTo={props.setNavigateTo}
                  />
               ))}
         </>
      );
   }
}
